import React from 'react'
import { NavBar, ProgressBar, Skeleton, tokens } from '@welbe/web-design-system'

import { Builder } from './Builder/Builder'
import { SurveySkeleton } from './Survey.skeleton'

import {
	Container,
	ContainerProgressBar,
	ContainerNavBar,
	Title,
	Text,
} from './SurveyForm.styles'
import useSurveyForm from './SurveyForm.hooks'
import { FormFinish } from '../components/FormFinish'

export const SurveyForm = (): JSX.Element => {
	const {
		handleBackToList,
		currentCampaignForm,
		onFinish,
		barPorcent,
		questionAnswerModels,
		isLoading,
		hasFilled,
		formError,
		setFormError,
		isLoadingForm,
		onChangeUpdateQuestionsAnswer,
	} = useSurveyForm()

	if (hasFilled) {
		return (
			<Container>{isLoading ? <SurveySkeleton /> : <FormFinish />}</Container>
		)
	}

	return (
		<Container>
			<ContainerNavBar>
				<NavBar title="Cuestionario NOM-035" onPrevious={handleBackToList} />
			</ContainerNavBar>
			<ContainerProgressBar>
				<ProgressBar
					percentValue={barPorcent}
					progressColor={tokens.color_secondary}
				/>
			</ContainerProgressBar>
			<Title>
				{isLoading ? <Skeleton width="80%" /> : currentCampaignForm.name}
			</Title>
			<Text>
				{isLoading ? <Skeleton width="60%" /> : currentCampaignForm.description}
			</Text>
			{isLoading ? (
				<SurveySkeleton />
			) : (
				<Builder
					data={currentCampaignForm}
					questionAnswerModels={questionAnswerModels}
					onFinish={onFinish}
					formError={formError}
					resetFormError={() => setFormError(false)}
					isLoadingForm={isLoadingForm}
					onChange={onChangeUpdateQuestionsAnswer}
				/>
			)}
		</Container>
	)
}
